import {
  DATA_PRODUCT_VIEW,
  SET_DM_CHAT_OPEN,
  SET_DM_PRODUCTS
} from '../types/dataMarketPlaceConstants'

export function setDataProductView(view) {
  return {
    type: DATA_PRODUCT_VIEW,
    payload: view
  }
}

export function setIsChatOpen(isChatOpen) {
  return {
    type: SET_DM_CHAT_OPEN,
    payload: isChatOpen
  }
}

export function setProducts(products) {
  return {
    type: SET_DM_PRODUCTS,
    payload: products
  }
}
